import { TransactionModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/outputs/transaction/paginated/transaction.model';
import { ColumnDef, createColumnHelper } from '@tanstack/react-table';

import { ChargePointChannelTransactionListDurationColumn } from './charge-point-channel-transaction-list-duration.column';
import { ChargePointChannelTransactionListKwhColumn } from './charge-point-channel-transaction-list-kwh.column';
import { ChargePointChannelTransactionListLocationColumn } from './charge-point-channel-transaction-list-location.column';
import { ChargePointChannelTransactionListOcpiSessionIdColumn } from './charge-point-channel-transaction-list-ocpi-session-id.column';
import { ChargePointChannelTransactionListStartedAtColumn } from './charge-point-channel-transaction-list-started-at.column';
import { ChargePointChannelTransactionListStateColumn } from './charge-point-channel-transaction-list-state.column';
import { ChargePointChannelTransactionListStoppedAtColumn } from './charge-point-channel-transaction-list-stopped-at.column';
import { ChargePointChannelTransactionListTokenAuthIdColumn } from './charge-point-channel-transaction-list-token-auth-id.column';
import { ChargePointChannelTransactionListTokenTypeColumn } from './charge-point-channel-transaction-list-token-type.column';
import { ChargePointChannelTransactionListTotalCostColumn } from './charge-point-channel-transaction-list-total-cost.column';

// /////////////////////////////////////////////////////////////////////////////
// DISPLAYING
// /////////////////////////////////////////////////////////////////////////////

export const chargePointChannelTransactionListColumnHelper =
  createColumnHelper<TransactionModel>();

type ResourceColumnType = ColumnDef<TransactionModel, any>[];

export const CHARGE_POINT_CHANNEL_TRANSACTION_LIST_COLUMN_LIST: ResourceColumnType =
  [
    chargePointChannelTransactionListColumnHelper.accessor(
      'ocpiSessionId',
      ChargePointChannelTransactionListOcpiSessionIdColumn,
    ),
    chargePointChannelTransactionListColumnHelper.accessor(
      'token.type',
      ChargePointChannelTransactionListTokenTypeColumn,
    ),
    chargePointChannelTransactionListColumnHelper.accessor(
      'token.authId',
      ChargePointChannelTransactionListTokenAuthIdColumn,
    ),
    chargePointChannelTransactionListColumnHelper.accessor(
      'location',
      ChargePointChannelTransactionListLocationColumn,
    ),
    chargePointChannelTransactionListColumnHelper.accessor(
      'state',
      ChargePointChannelTransactionListStateColumn,
    ),
    chargePointChannelTransactionListColumnHelper.accessor(
      'startedAt',
      ChargePointChannelTransactionListStartedAtColumn,
    ),
    chargePointChannelTransactionListColumnHelper.display(
      ChargePointChannelTransactionListDurationColumn,
    ),
    chargePointChannelTransactionListColumnHelper.accessor(
      'stoppedAt',
      ChargePointChannelTransactionListStoppedAtColumn,
    ),
    chargePointChannelTransactionListColumnHelper.accessor(
      'kwh',
      ChargePointChannelTransactionListKwhColumn,
    ),
    chargePointChannelTransactionListColumnHelper.accessor(
      'totalCost',
      ChargePointChannelTransactionListTotalCostColumn,
    ),
  ];

export const CHARGE_POINT_CHANNEL_TRANSACTION_LIST_COLUMN_ID_LIST =
  CHARGE_POINT_CHANNEL_TRANSACTION_LIST_COLUMN_LIST.flatMap((columnDef) => {
    if ('accessorKey' in columnDef) {
      return [columnDef.id ?? (columnDef.accessorKey as string)];
    }

    if (columnDef.id) {
      return [columnDef.id];
    }

    return [];
  });

export const CHARGE_POINT_CHANNEL_TRANSACTION_LIST_COLUMN_ORDER = [
  ...CHARGE_POINT_CHANNEL_TRANSACTION_LIST_COLUMN_ID_LIST,
];

export const CHARGE_POINT_CHANNEL_TRANSACTION_LIST_COLUMN_VISIBILITY =
  CHARGE_POINT_CHANNEL_TRANSACTION_LIST_COLUMN_ID_LIST.reduce(
    (columnVisibility, columnId) => {
      return { ...columnVisibility, [columnId]: true };
    },
    {},
  );
